import { Component, Host, Prop, h } from '@stencil/core';

@Component({
  tag: 'cpsl-spinner',
  styleUrl: 'cpsl-spinner.scss',
  shadow: true,
})
export class CpslSpinner {
  /**
   * Variant of the spinner
   * Default is 'pending'.
   */
  @Prop() variant?: 'idle' | 'pending' | 'error' | 'success' = 'pending';

  /**
   * Size of the spinner in pixels.
   * Default is 50.
   */
  @Prop() size?: number = 54;

  /**
   * Color of the spinner arc.
   * Default is 'var(--cpsl-color-foreground-0)'.
   */
  @Prop() barColor?: string;

  /**
   * Width of the spinner arc in pixels.
   * Default is 6.5.
   */
  @Prop() barWidth?: number;

  /**
   * Rotation speed of the spinner in seconds.
   * Default is 1.
   */
  @Prop() speed?: number = 1;

  render() {
    return (
      <Host
        style={{
          ['--height']: `${this.size}px`,
          ['--width']: `${this.size}px`,
          ['--bar-width']: `${this.barWidth ? this.barWidth : this.size * 0.12}px`,
          ...(this.barColor ? { ['--bar-color']: this.barColor } : {}),
        }}
      >
        <div class={{ loader: true, [this.variant]: true }} />
      </Host>
    );
  }
}
